import React, { createContext, useContext, useReducer, ReactNode } from "react";
import { ResendBatchRow } from "../Partner/BulkPaymentResend/ResendBatchRow";

interface ResendState {
	batchFile: Blob | null;
	selectedRecipients: ResendBatchRow[];
}

type Action = { type: "SET_FILE"; payload: Blob } | { type: "SET_SELECTED"; payload: ResendBatchRow[] } | { type: "CLEAR_ALL" };

const initialState: ResendState = {
	batchFile: null,
	selectedRecipients: []
};

function resendReducer(state: ResendState, action: Action): ResendState {
	switch (action.type) {
		case "SET_FILE":
			return { ...state, batchFile: action.payload };
		case "SET_SELECTED":
			return { ...state, selectedRecipients: action.payload };
		case "CLEAR_ALL":
			return { batchFile: null, selectedRecipients: [] };
		default:
			return state;
	}
}

interface ResendContextType {
	state: ResendState;
	dispatch: React.Dispatch<Action>;
}

const ResendContext = createContext<ResendContextType>({
	state: initialState,
	dispatch: () => null
});

export const ResendProvider = ({ children }: { children: ReactNode }) => {
	const [state, dispatch] = useReducer(resendReducer, initialState);
	return <ResendContext.Provider value={{ state, dispatch }}>{children}</ResendContext.Provider>;
};

export const useResend = () => useContext(ResendContext);
